module.exports = require("okta-i18n-bundles");


//////////////////
// WEBPACK FOOTER
// external "okta-i18n-bundles"
// module id = 41
// module chunks = 0